import { BOOKING_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "../../useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface IAhsBookingLinkParams {
  user_id: string;
  pet_id?: string | null;
  sub_service_id?: string | null;
}

export interface IAhsBookingLinkScriptData {
  whatsapp_text: string;
  phone_number?: string | null;
  link_url?: string;
}

export interface IAhsBookingLinkScriptResponse {
  status: boolean;
  message: string;
  data: IAhsBookingLinkScriptData;
}

export const useAhsBookingLinkScriptAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (params: IAhsBookingLinkParams): Promise<{ status: boolean; data: IAhsBookingLinkScriptData | null }> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const endpoint = BOOKING_APIS?.AHS_BOOKING_LINK_SCRIPT?.baseURL ?? "";
        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (value !== null && value !== undefined && `${value}` !== "") query.append(key, `${value}`);
        });

        return await axios
          .get(`${endpoint}?${query.toString()}`, {
            headers: { Authorization: `${accessToken}` },
          })
          .then((res: AxiosResponse<IAhsBookingLinkScriptResponse>) => {
            if (res.data?.status) return { status: true, data: res.data.data };
            return { status: false, data: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            return { status: false, data: null };
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, data: null };
      }
    },
    [configuration, sendCurl, captureError],
  );

  return { execute };
};
